import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
  StickyViewHeaderExtras,
} from 'components/StickyViewHeader'
import { TabBar, TabItem } from 'components/TabBar'
import { ViewHeading } from 'components/ViewHeading'
import link from 'infra/link'
import * as React from 'react'
import { observer } from 'mobx-react'
import { useRouteMatch } from 'react-router-dom'
import { FrameValue } from 'react-spring'

interface PayoutsAdminHeaderProps {
  scrollOffset: FrameValue<number>
  children?: React.ReactNode
}

/**
 * The PayoutsAdminHeader
 */
export default observer(function PayoutsAdminHeader({
  scrollOffset,
  children,
}: PayoutsAdminHeaderProps) {
  return (
    <>
      <StickyViewHeader
        bordered
        scrollOffset={scrollOffset}
        tabBar={
          <TabBar align="left">
            <PayoutsTabItem to={link.adminPayoutsReview()}>
              Pending
            </PayoutsTabItem>
            <PayoutsTabItem to={link.adminPayoutsTransactions()}>
              History
            </PayoutsTabItem>
          </TabBar>
        }
      >
        <StickyViewHeaderMain>
          <ViewHeading primaryText="Payouts" secondaryText="Transactions" />
        </StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
        <StickyViewHeaderExtras>{children}</StickyViewHeaderExtras>
      </StickyViewHeader>
    </>
  )
})

interface PayoutsTabItemProps {
  children?: React.ReactNode
  to: string
}

/**
 * Payouts Tab Item
 */
function PayoutsTabItem({ children, to }: PayoutsTabItemProps) {
  const match = useRouteMatch(to)
  return (
    <TabItem to={to} active={match?.isExact}>
      {children}
    </TabItem>
  )
}
